<!-- Property of OSF Global Services, Inc., (with its brand OSF Commerce). OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>
.answersWrapper {
    display: flex;
    justify-content: center;
}
@media (max-width: 767px) {
    .answersWrapper {
        align-items: center;
        flex-direction: column;
    }
}

.answerItem {
    display: block;
    cursor: pointer;
    position: relative;
    border: 0;
    padding: 0;
    min-height: calc(45rem / var(--nbAnswers));
    min-width: 100%;
}
@media (min-width: 768px) {
    .answerItem {
        min-height: 45rem;
        min-width: calc(100vw / var(--nbAnswers));
    }
}
.answerItem.disabled {
    cursor: auto;
}

.answer-button:focus-visible {
    outline: 3px solid #0070d2;
}

.answerContent {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 0 1.5rem;
    z-index: 1;
}
.answerSelectedIcon {
    left: 1.25rem;
    transition: filter 0.1s;
}
@media (min-width: 1280px) {
    .answerSelectedIcon {
        position: absolute;
    }
}
.answer-button:hover .answerSelectedIcon {
    filter: invert(1);
}
.answerSelectedIcon--inverted {
    filter: invert(1);
}
.answer-button:hover .answerSelectedIcon--inverted {
    filter: invert(0);
}
</style>

<template>
    <div class="template4wrapper">
        <div class="answersWrapper">
            <div
                v-for="(answer, index) in this.answers"
                :key="answer.id"
                class="answerItem"
                v-bind:class="[
                    answer.selected ? 'selected' : '',
                    answer.disabled ? 'disabled' : '',
                    answer.textColor === 'black' ? 'ti-text-color-black' : 'ti-text-color-white',
                    answer.backgroundColorText
                        ? `ti-bg-color-${answer.backgroundColorText}`
                        : (index + 1) % 3 === 0
                        ? 'ti-bg-color-black'
                        : (index + 1) % 2 === 0
                        ? 'ti-bg-color-red'
                        : 'ti-bg-color-white ti-text-color-black',
                ]"
                :style="answerStyle"
                :title="answer.text"
                v-on:click="selectAnswer(answer.id)"
                :data-cbt="getDataCbtValue(answer)"
            >
                <div class="answerContent">
                    <div class="ti-fs-28 ti-fs-md-56">{{ answer.title }}</div>
                    <button
                        :data-cbt="getDataCbtValue(answer)"
                        class="answer-button ti-btn mt-16 w-auto px-20 px-lg-50 position-relative"
                        :class="[
                            answer.textColor === 'black'
                                ? 'ti-btn-third bg-transparent'
                                : (index + 1) % 3 !== 0 && (index + 1) % 2 !== 0
                                ? 'ti-btn-third'
                                : 'ti-btn-ghost',
                        ]"
                        v-on:click="selectAnswer(answer.id)"
                        :aria-label="answer.selected ? selectedButtonText : buttonText + ' ' + answer.title"
                    >
                        <img
                            class="answerSelectedIcon mr-8"
                            :class="
                                (index + 1) % 3 !== 0 && (index + 1) % 2 !== 0 ? 'answerSelectedIcon--inverted' : ''
                            "
                            v-if="answer.selected"
                            :src="images.checkmark"
                            :alt="selectedButtonText"
                            :data-cbt="getDataCbtValue(answer)"
                        />
                        {{ answer.selected ? selectedButtonText : buttonText }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Q4Template",
    data() {
        return {
            localStateAnswers: {},
        };
    },
    computed: {
        quizData: function () {
            return this.$store.state.quizData;
        },
        question: function () {
            return this.$store.state.questionData;
        },
        answers: function () {
            return this.$store.state.questionData.answers;
        },
        images: function () {
            return this.$store.state.quizData.images;
        },
        buttonText: function () {
            return this.$store.state.quizData.translations.templateq1buttontext;
        },
        selectedButtonText: function () {
            return this.$store.state.quizData.translations.templateq1selectedbuttontext;
        },
        answerStyle() {
            return {
                "--nbAnswers": this.answers.length,
            };
        },
    },
    methods: {
        selectAnswer: function (aid) {
            this.$store.commit("setAnswer", aid);
            let data = {
                quizid: this.quizData.quizid,
                qid: this.question.id,
                aid: [aid],
            };
            this.$store.dispatch("submitQuestion", data);
        },
        getDataCbtValue: function (answer) {
            let data = {
                "event" : "GiftFinderNavigation",
                "eventTypes": "click, link",
                "W-cat": "Gift Finder",
                "W-act": null,
                "W-lib": answer.englishTranslation
            }

            let questionStep;
            switch(this.question.id) {
                case "forYouOrGift" : {
                    questionStep = "Step 1";
                    break;
                }
                case "herHimUnisex" : {
                    questionStep = "Step 2";
                    break;
                }
                case "style"        : {
                    questionStep = "Step 3";
                    break;
                }
                case "dialColor"    : {
                    questionStep = "Step 4";
                    break;
                }
                case "strapMaterial": {
                    questionStep = "Step 5";
                    break;
                }
                case "price"        : {
                    questionStep = "Step 6";
                    break;
                }
                default             : {
                    questionStep = "Gift Finder";
                    break;
                }
            }

            data['W-act'] = questionStep;

            return JSON.stringify(data);
        }
    },
};
</script>
